import { render, staticRenderFns } from "./AddSectionForm.vue?vue&type=template&id=6524f1a8&"
import script from "./AddSectionForm.vue?vue&type=script&lang=js&"
export * from "./AddSectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports